var NetUtil = require('./ajax').default;
var config = require('../config.js');
var url = require("../utils/url.js").default;


module.exports = function(options, ignore) {
  var data = require("../default/data.js");

  options = Object.assign({
    method:'get',
    dataType:'json'
  }, options);

  options.url = (options.url || "").indexOf('http') == 0 ? options.url : config.api + options.url;

  var urlobj = url(options.url);
  if(!ignore && data.user && data.user.token) {
    urlobj.setParam('x-token', data.user.token);
  }

  options.url = urlobj.toString();
  console.log('request', options.url);
  return NetUtil.ajax(options);
};



// WEBPACK FOOTER //
// ./src/utils/request.js